import React from "react";
import { Link } from "react-router-dom";

import "../css/categoriastarjetas.css";

const categoriastarjetas = (props) => {
    const {titulo, img, page, disabled} = props;
  return (
    <div className="cont">
      <Link 
      className={`card text-center mb-3 cardCategorias ${disabled ? 'disabled' : ''} shadow-sm`}
      to={page}>
        <div className="card-body mt-2">
          <div className="imgCentral">
            {img}
          </div>
          <h4 className="card-title mt-2">{titulo}</h4>
        </div>
      </Link>
    </div>
  );
}

export default categoriastarjetas;
